<div class="p-4 sm:p-6 space-y-4 sm:space-y-6">
  <!-- Header -->
  <div class="flex items-center justify-between gap-3">
    <div class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">
        POS ilovasi versiyalari
      </h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
        <code class="font-mono">vpk pack</code> chiqargan papkadagi barcha fayllarni yuklang —
        kassalar yangilanishni o'zi topib oladi
      </p>
    </div>
    <div class="flex gap-2 shrink-0">
      <button
        (click)="load()"
        [disabled]="loading()"
        class="p-2 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
      >
        <lucide-icon
          [img]="RefreshCw"
          class="w-4 h-4 text-gray-500"
          [class.animate-spin]="loading()"
        ></lucide-icon>
      </button>
      <button
        (click)="openCreate()"
        class="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium transition-colors"
      >
        <lucide-icon [img]="Upload" class="w-4 h-4"></lucide-icon>
        <span class="hidden sm:inline">Yangi versiya</span>
      </button>
    </div>
  </div>

  @if (loading() && releases().length === 0) {
    <div class="flex justify-center py-16">
      <div
        class="w-8 h-8 border-4 border-gray-200 border-t-green-600 rounded-full animate-spin"
      ></div>
    </div>
  } @else if (releases().length === 0) {
    <div class="flex flex-col items-center justify-center py-16 text-gray-400">
      <lucide-icon [img]="Download" class="w-12 h-12 mb-3"></lucide-icon>
      <p class="text-sm">Hozircha chiqarilgan versiya yo'q</p>
    </div>
  } @else {
    <div
      class="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900"
    >
      <table class="w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400">
          <tr>
            <th class="text-left font-medium px-4 py-3">Versiya</th>
            <th class="text-left font-medium px-4 py-3">Kanal</th>
            <th class="text-left font-medium px-4 py-3">Eng past ruxsat</th>
            <th class="text-left font-medium px-4 py-3">Hajm</th>
            <th class="text-left font-medium px-4 py-3">Chiqarilgan</th>
            <th class="text-right font-medium px-4 py-3">Amal</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
          @for (r of releases(); track r.id) {
            <tr [class.opacity-50]="!r.isActive">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="font-mono font-medium text-gray-900 dark:text-gray-100">{{
                    r.version
                  }}</span>
                  @if (r.isLatest) {
                    <span
                      class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-400 text-xs font-medium"
                    >
                      <lucide-icon [img]="CheckCircle2" class="w-3 h-3"></lucide-icon>
                      joriy
                    </span>
                  }
                  @if (r.isMandatory) {
                    <span
                      class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-400 text-xs font-medium"
                    >
                      <lucide-icon [img]="AlertTriangle" class="w-3 h-3"></lucide-icon>
                      majburiy
                    </span>
                  }
                </div>
                @if (r.releaseNotes) {
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 max-w-md">
                    {{ r.releaseNotes }}
                  </p>
                }
              </td>
              <td class="px-4 py-3 text-gray-600 dark:text-gray-300">{{ r.channel }}</td>
              <td class="px-4 py-3 font-mono text-gray-600 dark:text-gray-300">
                {{ r.minSupportedVersion || '—' }}
              </td>
              <td class="px-4 py-3 text-gray-600 dark:text-gray-300">
                {{ formatSize(r.totalSizeBytes) }}
              </td>
              <td class="px-4 py-3 text-gray-600 dark:text-gray-300">
                {{ r.publishedAt | date: 'dd.MM.yyyy HH:mm' }}
              </td>
              <td class="px-4 py-3 text-right">
                <div class="inline-flex items-center gap-1.5">
                  <button
                    (click)="toggleActive(r)"
                    class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 text-xs transition-colors"
                    [title]="
                      r.isActive ? 'Qaytarib olish — mijozlar bu versiyani olmaydi' : 'Qayta yoqish'
                    "
                  >
                    <lucide-icon [img]="Undo2" class="w-3.5 h-3.5"></lucide-icon>
                    {{ r.isActive ? 'Qaytarib olish' : 'Yoqish' }}
                  </button>
                  <button
                    (click)="confirmDelete(r)"
                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 dark:border-gray-800 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 hover:border-red-300 transition-colors"
                    title="Butunlay o'chirish — paketlar R2 dan ham o'chadi"
                  >
                    <lucide-icon [img]="Trash2" class="w-3.5 h-3.5"></lucide-icon>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<!-- Yuklash oynasi -->
@if (dialogOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
    <div
      class="w-full max-w-lg rounded-2xl bg-white dark:bg-gray-900 shadow-xl max-h-[90vh] overflow-y-auto"
    >
      <div
        class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-800"
      >
        <h2 class="font-semibold text-gray-900 dark:text-gray-100">Yangi versiya chiqarish</h2>
        <button
          (click)="closeDialog()"
          [disabled]="submitting()"
          class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40"
        >
          <lucide-icon [img]="X" class="w-4 h-4 text-gray-500"></lucide-icon>
        </button>
      </div>

      <div class="px-5 py-4 space-y-4">
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label
              for="rel-version"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Versiya *</label
            >
            <input
              id="rel-version"
              type="text"
              [(ngModel)]="form.version"
              placeholder="1.0.1"
              class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm font-mono"
            />
            <p class="text-xs text-gray-400 mt-1">Paketdagi versiya bilan bir xil bo'lishi shart</p>
          </div>
          <div>
            <label
              for="rel-channel"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Kanal</label
            >
            <select
              id="rel-channel"
              [(ngModel)]="form.channel"
              class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm"
            >
              <option value="win">win</option>
            </select>
          </div>
        </div>

        <div>
          <label
            for="rel-min"
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Eng past ruxsat etilgan versiya</label
          >
          <input
            id="rel-min"
            type="text"
            [(ngModel)]="form.minSupportedVersion"
            placeholder="bo'sh qoldirsa — majburiy chegara yo'q"
            class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm font-mono"
          />
          <p class="text-xs text-gray-400 mt-1">
            Bundan past versiyadagi kassalarda ilova bloklanadi va yangilash majburiy bo'ladi. Faqat
            backendda buzuvchi o'zgarish bo'lganda to'ldiring.
          </p>
        </div>

        <label class="flex items-start gap-2 cursor-pointer">
          <input type="checkbox" [(ngModel)]="form.isMandatory" class="mt-1 rounded" />
          <span class="text-sm text-gray-700 dark:text-gray-300">
            Bu yangilanish majburiy
            <span class="block text-xs text-gray-400"
              >Barcha eski versiyadagi kassalar darhol yangilashga majbur bo'ladi</span
            >
          </span>
        </label>

        <div>
          <label
            for="rel-notes"
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Nima o'zgardi</label
          >
          <textarea
            id="rel-notes"
            [(ngModel)]="form.releaseNotes"
            rows="3"
            class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm"
          ></textarea>
        </div>

        <div>
          <label
            for="rel-files"
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Fayllar *</label
          >
          <input
            id="rel-files"
            type="file"
            multiple
            (change)="onFilesPicked($event)"
            class="w-full text-sm text-gray-600 dark:text-gray-300 file:mr-3 file:px-3 file:py-1.5 file:rounded-lg file:border-0 file:bg-gray-100 dark:file:bg-gray-800 file:text-sm"
          />
          @if (selectedFiles().length > 0) {
            <p class="text-xs text-gray-500 mt-2">
              {{ selectedFiles().length }} ta fayl · {{ formatSize(totalSelectedSize) }}
            </p>
            <ul class="mt-2 space-y-1">
              @for (f of selectedFiles(); track f.name) {
                <li
                  class="flex items-center justify-between gap-2 px-2.5 py-1.5 rounded-lg bg-gray-50 dark:bg-gray-800 text-xs"
                >
                  <span class="font-mono truncate text-gray-700 dark:text-gray-300">{{
                    f.name
                  }}</span>
                  <div class="flex items-center gap-2 shrink-0">
                    <span class="text-gray-400">{{ formatSize(f.size) }}</span>
                    <button
                      type="button"
                      (click)="removeFile(f.name)"
                      class="p-0.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700"
                    >
                      <lucide-icon [img]="X" class="w-3 h-3 text-gray-500"></lucide-icon>
                    </button>
                  </div>
                </li>
              }
            </ul>
          }
          @if (manifestMissing) {
            <p
              class="mt-2 flex items-start gap-1.5 text-xs text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 rounded-lg px-2.5 py-2"
            >
              <lucide-icon [img]="AlertTriangle" class="w-3.5 h-3.5 mt-0.5 shrink-0"></lucide-icon>
              <span
                ><code class="font-mono">releases.{{ form.channel }}.json</code> fayli tanlanmagan.
                Ilova yangilanishni aynan shu manifest orqali topadi —
                <code class="font-mono">vpk pack</code> chiqargan papkadagi
                <strong>barcha</strong> fayllarni tanlang.</span
              >
            </p>
          }
        </div>

        @if (submitting()) {
          <div class="space-y-1.5">
            <div class="h-2 rounded-full bg-gray-100 dark:bg-gray-800 overflow-hidden">
              <div
                class="h-full bg-green-600 transition-all"
                [style.width.%]="uploadProgress()"
              ></div>
            </div>
            <p class="text-xs text-gray-500 text-center">{{ phaseLabel }} — oynani yopmang</p>
          </div>
        }

        @if (error()) {
          <p
            class="text-xs text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-lg px-2.5 py-2"
          >
            {{ error() }}
          </p>
        }
      </div>

      <div class="flex justify-end gap-2 px-5 py-4 border-t border-gray-100 dark:border-gray-800">
        <button
          (click)="closeDialog()"
          [disabled]="submitting()"
          class="px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-800 text-sm hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40"
        >
          Bekor qilish
        </button>
        <button
          (click)="publish()"
          [disabled]="!canSubmit"
          class="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 disabled:opacity-40 text-white text-sm font-medium"
        >
          <lucide-icon [img]="Upload" class="w-4 h-4"></lucide-icon>
          Chiqarish
        </button>
      </div>
    </div>
  </div>
}

<p-confirmdialog [style]="{ width: 'min(32rem, 92vw)' }" />
